// user-client/src/state/storage.js
// ✅ NOTE:
// 기존 파일이 'stroage.js' (오타)로 존재하므로,
// import 경로 './storage' 가 깨지지 않도록 "정상 파일명"을 하나 더 둔다.

export * from './stroage';

import { readString, writeString, readJSON, writeJSON } from './stroage';

// ✅ languageState.js 에서 기대하는 alias
export function safeGet(key, fallback = '') {
  return readString(key, fallback);
}

export function safeSet(key, value) {
  return writeString(key, value);
}

// ✅ soundState.js 에서 기대하는 alias
export function safeGetJSON(key, fallback = null) {
  return readJSON(key, fallback);
}

export function safeSetJSON(key, value) {
  return writeJSON(key, value);
}